import LoadingSpinner from "../LoadingSpinner";
import { TableCell, TableRow } from "../ui/table";

export const TableLoading = ({ colSpan }: { colSpan: number }) => {
  return (
    <TableRow>
      <TableCell colSpan={colSpan} className="py-8 text-center">
        <div className="flex items-center justify-center">
          <LoadingSpinner />
        </div>
      </TableCell>
    </TableRow>
  );
};
